export default "src/content/themes/association-wordpress-theme/img/d5f91909a876c1d4d3900e1d492fe5b4.jpg";